import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseContainer, Toast } from '@stylehaven/components';
import { groupBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { map, shareReplay, take } from 'rxjs/operators';
import { ToastGroupGuard, createGroupedToast } from '../../common/entities/common/toast-group.entity';
import { ToastsSandbox } from '../sandbox/toasts.sandbox.service';

@Component({
    standalone: false,
    selector: 'med-toasts-container',
    templateUrl: './toasts-container.component.html'
})
export class ToastsContainerComponent extends BaseContainer implements OnInit, OnDestroy {
    public toasts$: Observable<Toast[]>;

    constructor(private readonly sandbox: ToastsSandbox) {
        super();
        this.sandbox.clearToasts();
    }

    ngOnInit() {
        this.toasts$ = this.getToasts();
    }

    private getToasts(): Observable<Toast[]> {
        const toasts$: Observable<Toast[]> = this.sandbox.getToasts().pipe(
            map(toasts => groupBy(toasts, 'message')),
            map(groups =>
                Object.entries(groups).flatMap(([key, toasts]) => {
                    if (key !== 'undefined') {
                        return [createGroupedToast(toasts)];
                    } else {
                        return toasts;
                    }
                })
            ),
            shareReplay(1)
        );

        return toasts$;
    }

    public closeToast(id: number): void {
        this.toasts$.pipe(take(1)).subscribe(toasts => {
            const toast: Toast | undefined = toasts.find(toast => toast.id === id);
            if (toast && ToastGroupGuard(toast)) {
                toast.childToasts.forEach(toast => this.sandbox.closeToast(toast.id));
            } else {
                this.sandbox.closeToast(id);
            }
        });
    }
}
